import deleteIcon from './delete.png';
import './Home.css';
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
//import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import React, { Component, useState, useEffect } from "react";
//import 'semantic-ui-css/semantic.js';
//import 'semantic-ui-css/semantic.min.css';
//import { useLocation, useParams } from 'react-router-dom';
//import { Router } from 'react-router-dom';
import DatePicker from "react-datepicker";
import 'semantic-ui-css/semantic.min.css'; // Or your Semantic UI CSS file
import "react-datepicker/dist/react-datepicker.css";
import withNavigateHook from '../../myRoutes';
//import { Dropdown } from 'react-day-picker';
//import Receipt from '../Receipt/Receipt';
//import Override from '../Override/Override';
//import { Dropdown } from 'semantic-ui-react'
import axios from 'axios';
import Select from 'react-select';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.handleOpen = React.createRef()
        this.overrideOpen = React.createRef()
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });

        // SET STATE
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            gender: "",
            firstname: "",
            lastname: "",
            firsName: "",
            // dateofbirth: new Date(),
            familystatus: "",
            phonenumber: "",
            //address: "",
            joindate: new Date(),
            selectedDate: new Date(),
            emailaddress: "",
            // maritalstatus: "",
            country: "",
            city: "",
            jb: "",
            db: "",
            email: "",
            depFullname: "",
            depGender: "",
            depPhonenumber: "",
            depRelationship: "",
            depCountry: "",
            groupUsers: [],
            groupMembers: [],
            groupUserDetails: [],
            memberGender: "",
            memberId: "",
            memberfirstname: "",
            memberlastname: "",
            memberphone: "",
            memberemail: "",
            membercountry: "",
            membercity: "",
            memberfound: "",

            memberaddress: "",
            memberdob: new Date(),
            memberjoindate: new Date(),
            membermarital: "",

            memberDependants: [],
            depSelectedGender: "",
            depSelectedCountry: "",
            depSelectedRelationship: "",
            userRole: "",
            //-------------------
            price: 0,
            total: 0,
            selectedProduct: "",
            products: [],
            foods: [],
            drinks: [],
            cart: [],
            refreshKey: 0,
            sales: [],
            salesRecords: [],
            username: "bruno",
            stock: 0,
            balanceStock: 0,
            categItem: "",
            prodId: "",

            open: false,
            shopname: "",
            items: []
            // todaySales:0
        }
    }
    groupUserList = [];
    memberDependants = [];

    genders = [
        { label: "Female", value: "Female" },
        { label: "Male", value: "Male" },
        { label: "Other", value: "Other" }
    ]

    relationships = [
        { label: "Brother", value: "Brother" },
        { label: "Daughter", value: "Daughter" },
        { label: "Father", value: "Father" },
        { label: "Husband", value: "Husband" },
        { label: "Mother", value: "Mother" },
        { label: "Partner", value: "Partner" },
        { label: "Sister", value: "Sister" },
        { label: "Son", value: "Son" },
        { label: "Wife", value: "Wife" },

    ]
    maritalstatus = [
        { label: "Divorced", value: "Divorced" },
        { label: "Married", value: "Married" },
        { label: "Single", value: "Single" },
        { label: "Widow", value: "Widow" },
        { label: "Widow man", value: "Widow man" }
    ]
    countries = [
        { label: "Angola", value: "Angola" },
        { label: "Cote d'Ivoire", value: "Cote d'Ivoire" },
        { label: "Congo Democratic", value: "Congo Democratic" },
        { label: "Congo Republic", value: "Congo Republic" },
        { label: "Ghana", value: "Ghana" },
        { label: "South Africa", value: "South Africa" },
        { label: "Zimbabwe", value: "Zimbawe" },
    ]

    countriesCities = [
        { label: "Angola", value: "Luanda" },
        { label: "Angola", value: "Cubango" },
        { label: "Cote d'Ivoire", value: "Abidjan" },
        { label: "Congo Democratic", value: "Kinshasa" },
        { label: "Congo Democratic", value: "Lubumbashi" },
        { label: "Congo Democratic", value: "Mbuji Mayi" },
        { label: "Congo Republic", value: "Brazzaville" },
        { label: "Congo Republic", value: "Pointe Noire" },
        { label: "Congo Republic", value: "Dolisie" },
        { label: "Congo Republic", value: "Nkayi" },
        { label: "Congo Republic", value: "Ouesso" },
        { label: "Ghana", value: "Accra" },
        { label: "South Africa", value: "Johannesburg" },
        { label: "South Africa", value: "Cape Town" },
        { label: "South Africa", value: "Tswane" },
        { label: "South Africa", value: "Limpopo" },
        { label: "South Africa", value: "East London" },
        { label: "South Africa", value: "Durban" },
        { label: "South Africa", value: "Port Elizabeth" },
        { label: "Zimbabwe", value: "Bulawayo" },
        { label: "Zimbabwe", value: "Harare" }
    ]

    setGenderChange = (e) => {
        this.setState({ memberGender: e });
    }
    setMaritalChange = (e) => {
        this.setState({ membermarital: e });
    }
    setCountry = (e) => {
        this.setState({ country: e });
        this.getCountryCities(e);
    }
    setCity = (e) => {
        this.setState({ city: e });
    }
    setFirstName = (e) => {
        this.setState({ firstname: e.target.value });
    }
    setLastName = (e) => {
        this.setState({ lastname: e.target.value });
    }
    setPhoneNumber = (e) => {
        this.setState({ phonenumber: e.target.value });
    }

    handleDateOfBirthChange = (e) => {
        this.setState({
            memberdob: e.target.value
        });
        // console.log('----' + e.target.value)
    }


    componentDidUpdate() {
        window.onpopstate = e => {
            if (window.confirm('Are you sure you want to log out?')) {
                this.appLogout();
            } else {
                this.props.navigate('/home', {
                    state: {
                        db: this.state.db, email: this.state.email,
                        firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
                    }
                });
            }
        }
    }


    handleInputChange = (e) => {
        const inputDate = e.target.value;
        const parsedDate = new Date(this.inputDate);

        if (!isNaN(this.parsedDate)) {
            this.setState({
                dateofbirth: this.parsedDate
            });
        }
    };

    handleJoinDateChange = (e) => {
        this.setState({
            memberjoindate: e.target.value
        });
    }

    setEmailAddress = (e) => {
        this.setState({
            emailaddress: e.target.value
        });
    };
    setAddress = (e) => {
        this.setState({
            memberaddress: this.titleCase(e.target.value)
        });
    };
    titleCase = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }
    getCountryCities = (country) => {
        let countryCity = [];
        {
            this.countriesCities.map(item => {
                var obj = {};
                if (item.label === country) {
                    obj["label"] = item.value;
                    obj["value"] = item.value;
                    countryCity.push(obj)
                }
            })
        }
        this.setState({ countryCities: countryCity });
    }

    saveRegistration = async (e) => {

        if (this.state.memberfirstname === "") {
            alert("Please select a member to register!");
            return false;
        }
        if (this.memberDependants.length === 0) {
            alert("Please add dependents before submitting!");
            return false;
        }
        if (document.getElementById("cbxterms").checked === false) {
            alert("Please accept the terms and conditions!");
            return false;
        }
        else {
            let config = {
                headers: { 'Accept': 'application/json' },
                params: {
                    'businessname': this.props.location.state.db,
                    'userid': this.state.memberId,
                    'name': this.state.memberfirstname,
                    'surname': this.state.memberlastname,
                    'dob': this.state.memberdob,
                    'gender': this.state.memberGender,
                    'family_status': this.state.membermarital,
                    'email': this.state.memberemail,
                    'phone': this.state.memberphone,
                    'city': this.state.membercity,
                    'country': this.state.membercountry,
                    'address': this.state.memberaddress,
                    'join_date': this.state.memberjoindate,
                    'isnewmember': this.memberfound,
                    'dependents': this.memberDependants
                }
            }
            // const url = "http://localhost/kimvuka-php/api/registerMember.php";
            const url = "https://testmembership.bktsystems.com/api/registerMember.php";
            const response = await axios.get(url, config
            )
           //  console.log(response.data);
            this.setState({ firstName: "", lastName: "", emailAddress: "", mobilePhone: "", gender: "", userName: "", passWord: "", businessName: "", country: "", city: "" });
            if (response.data.includes("Member registration sucessfull.") === true) {
              
                document.getElementById('successRegstration').style.display = "block";
                document.getElementById('btnSubmit').style.display = "none";
                //alert("Thank you, your registration request has been received. We will contact you once your account is setup.");
            }
            else {
                //alert("There was an error, please try again later.");
                document.getElementById('failRegstration').style.display = "block";
            }
        }
        // e.stopPropagation();
        //this.sendRegistration();
    }
    sendRegistration = async (e) => {
        console.log(">>>>> Module under construction!")
    }
    getExistingMemberData = (fullname) => {
        // this.state.groupMembers.map(key => {
        for (let i = 0; i < this.state.groupMembers.length; i++) {
            this.setState({ memberaddress: "", memberdob: "", membermarital: "", memberjoindate: "" })
            if (fullname === this.state.groupMembers[i].name + ' ' + this.state.groupMembers[i].surname) {
                this.setState({
                    memberaddress: this.state.groupMembers[i].address, memberdob: this.state.groupMembers[i].dob,
                    membermarital: this.state.groupMembers[i].family_status, memberjoindate: this.state.groupMembers[i].join_date
                })
                break;
            }
        }
    }

    goToMenu = (e) => {
        e.preventDefault();
        this.props.navigate('/menu', {
            state: {
                db: this.props.location.state.db, email: this.props.location.state.email,
                firstname: this.props.location.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
            }
        });
    }

    loadGroupAllUsers = async (e) => {
        // console.log("jnnnndb" + this.props.history.location.state.db)
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }

        }
        //  const url = "http://localhost/kimvuka-php/api/getGroupAllUsers.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupAllUsers.php";
        const response = await axios.get(url, config);
        //  console.log(response.data);

        this.setState({ groupUsers: response.data });
        if (this.props.location.state.userRole === 'user') {
            response.data.map(key => {
                if ((this.props.location.state.email === key.emailaddress) && (key.role === 'user')) {
                    this.groupUserList.push({
                        label: key.firstname + " " + key.lastname, value: key.firstname + " " + key.lastname
                    });
                }
            })
        }
        else {
            response.data.map(key => {                
                    this.groupUserList.push({
                        label: key.firstname + " " + key.lastname, value: key.firstname + " " + key.lastname
                    });                
            })
        }
        // console.log(this.groupUserList)
    }

    loadGroupAllMembers = async (e) => {

        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }

        }
        // const url = "http://localhost/kimvuka-php/api/getGroupAllmemberships.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupAllmemberships.php";
        const response = await axios.get(url, config);
        //  console.log(response.data);
        this.setState({ groupMembers: response.data });
    }

    loadGroupUserDetails = async (fullname) => {

        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db, "fullname": fullname }

        }
        // const url = "http://localhost/kimvuka-php/api/getGroupUserDetails.php";
        const url = "https://testmembership.bktsystems.com/api/getGroupUserDetails.php";
        const response = await axios.get(url, config);
        const memberfound = false
        this.memberfound = this.checkMemberRegistrationExist(fullname);
        if (this.memberfound === true) {
            document.getElementById('memberfoundlabel').style.display = "block";
        }
        else {
            document.getElementById('memberfoundlabel').style.display = "none";
        }
        //  console.log(response.data);
        this.setState({
            groupUserDetails: response.data, memberId: response.data[0]['id'], memberGender: response.data[0]['gender'], memberfirstname: response.data[0]['firstname'], memberlastname: response.data[0]['lastname'],
            memberphone: response.data[0]['mobilephone'], memberemail: response.data[0]['emailaddress'], membercity: response.data[0]['city'], membercountry: response.data[0]['country']

        });
    }

    checkMemberRegistrationExist = (fullname) => {
        let found = false;
        if (Array.isArray(this.state.groupMembers)) {
            this.state.groupMembers.map(key => {
                let strfullname = key.name + ' ' + key.surname
                if (fullname === strfullname) {
                    found = true
                }
            })
        }
        return found;
    }

    setUserMemberChange = (fullname) => {
        this.loadGroupUserDetails(fullname);
        this.getExistingMemberData(fullname);
        this.setState({ isFocused: 'green' })
    }

    setDepFullName = (e) => {
        this.setState({ depFullname: this.titleCase(e.target.value) });
    }
    setdepPhoneNumber = (e) => {
        this.setState({ depPhonenumber: e.target.value });
    }

    setDepGenderChange = (e) => {
        this.setState({ depGender: e, depSelectedGender: e.label });
    }
    setdepCountry = (e) => {
        this.setState({ depCountry: e, depSelectedCountry: e.label });
    }
    setdepRelationship = (e) => {
        this.setState({ depRelationship: e, depSelectedRelationship: e.label });
    }

    //------------------------------------------------- RECYCLE STUFF --------------------------

    loadMmembers = async (e) => {
        // console.log("jnnnndb" + this.props.history.location.state.db)
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": this.props.history.location.state.db }

        }
        const url = "http://localhost/reactcrudphp/api/getProduct.php";
        // const url = "https://phpapi.bktsystems.com/api/getProduct.php";
        const response = await axios.get(url, config);
    }

    componentDidMount = () => {
        this.loadGroupAllUsers();
        this.loadGroupAllMembers();
        this.setState({
            db: this.props.location.state.db, firstname: this.props.location.state.firstname,
            email: this.props.location.state.email, userRole: this.props.location.state.userRole
        });

        // console.log(this.props.location.state.db)
    }


    Receipt = () => {
        this.handleOpen.current.handleOpen();
    }

    customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? 'green' : 'red',
        }),
    };
    // -------------------------------------------- RECYCLE END ------------------------------------------------------------

    appLogout = (e) => {
        // e.preventDefault();
        this.props.navigate('/', { state: { db: '', email: '', firstname: '' } });
        //this.props.history.push({ pathname: '/', state: { fullname: "" } })
    }
    removeDependant = (index, e) => {
        this.memberDependants.splice(index, 1);
        this.memberDependants.filter((el, idx) => idx !== index);
        this.setState({ memberDependants: this.memberDependants });
        // console.log(">>>> Removed at index " + this.cart.length);
    }

    addDependent = () => {
        // if (this.memberfirstname === "") {
        //     alert("Please select a member to register!");
        //     return false;
        // }
        // if (this.memberDependants.length === 0) {
        //     alert("Please add dependents before submitting!");
        //     return false;
        // }
        if ((this.state.depGender === "") || (this.state.depFullname === "") || (this.state.depCountry.includes("Select") === true)
            || (this.state.depRelationship.includes("Select") === true) || (this.state.depCountry === "") || (this.state.depRelationship === "")) {
            alert("Please prodive the dependant details!");
            return false;
        }
        else {
            this.memberDependants.push({
                depGender: (this.state.depGender), depFullname: (this.state.depFullname), depPhonenumber: (this.state.depPhonenumber),
                depCountry: (this.state.depCountry), depRelationship: (this.state.depRelationship)
            });
            // console.log(this.memberDependants);
            this.setState({
                depGender: "", depFullname: "", depPhonenumber: "", depCountry: "", depRelationship: "", depSelectedGender: "",
                depSelectedCountry: "", depSelectedRelationship: ""
            });
            //this.clearValue();
            // this.setState({ memberDependants: this.memberDependants });
            // return null;
        }
    }

    numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    render() {
        return (
            <div className='mainDivHome' style={{ border: '2px solid rgb(89, 100, 95)', borderRadius: "10px" }}>
                <div style={{ width: "100%" }}>
                    <span>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "white", fontStyle: "italic" }} onClick={this.goToMenu}>Main Menu</Button>
                        <Button style={{ paddingLeft: "5px", width: "50%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "#ff7400", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                    </span>
                </div>
                <div style={{ paddingTop: "10px", textAlign: "center" }}>
                    <span style={{ fontStyle: "italic" }} className="businessname"><h4>{this.props.location.state.db}</h4></span>
                    <span style={{ fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                    <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>
                </div>
                <div>
                    {/* <Form> */}
                    <div style={{ textAlign: "center", paddingTop: "5px" }}><Label> <h4>MEMBER REGISTRATION </h4></Label></div>
                    <div id="memberfoundlabel" style={{ textAlign: "center", fontStyle: 'italic', display: "none" }}>
                        <Label style={{ color: "orangered" }}>This member has an active registration for the group!</Label></div>
                    <div style={{ paddingBottom: "10px" }}>
                        <span className=""><h5>MEMBER'S DETAILS</h5></span>
                    </div>
                    <FormGroup>
                        <Label for='users'>Select user</Label>
                        <Select
                            options={this.groupUserList}
                            maxMenuHeight="100%"
                            defaultInputValue=""
                            onChange={opt => this.setUserMemberChange(opt.label)}
                            styles={this.customStyles}
                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for='gender'>Gender</Label>
                        <Select
                            options={this.genders}
                            maxMenuHeight="100%"
                            defaultInputValue={this.state.memberGender}
                            onChange={opt => this.setGenderChange(opt.label)}
                            key={this.state.memberGender}
                        //isOptionDisabled={true}
                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for='marital'>Marital status</Label>
                        <Select
                            options={this.maritalstatus}
                            maxMenuHeight="100%"
                            defaultInputValue={this.state.membermarital}
                            key={this.state.membermarital}
                            onChange={opt => this.setMaritalChange(opt.label)}
                            styles={this.customStyles}
                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for='firstname'>First name</Label>
                        <Input
                            type='text'
                            id='firstName'
                            name='firstName'
                            value={this.state.memberfirstname}
                        // onChange={this.setFirstName}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for='lastname'>Last name</Label>
                        <Input
                            type='text'
                            id='lastName'
                            name='lastName'
                            value={this.state.memberlastname}
                        // onChange={this.setLastName}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label style={{ marginRight: "5px" }}>
                            Date of birth
                        </label>
                        <Input className="regDatePicker"
                            //dateFormat="dd-MM-yyyy"
                            type='date'
                            value={this.state.memberdob}
                            onChange={(date) => this.handleDateOfBirthChange(date)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for='phonenumber'>Phone number</Label>
                        <Input
                            type='number'
                            id='phonenumber'
                            name='phonenumber'
                            placeholder="+271234567896"
                            value={this.state.memberphone}
                            onChange={this.setPhoneNumber}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email address</Label>
                        <Input
                            id="email"
                            name="email"
                            placeholder=""
                            onChange={this.setEmailAddress}
                            type="email"
                            value={this.state.memberemail}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for='country'>Country</Label>
                        <Select
                            options={this.countries}
                            maxMenuHeight="100%"
                            defaultInputValue={this.state.membercountry}
                            onChange={opt => this.setCountry(opt.label)}
                            key={this.state.membercountry}
                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for='city'>City</Label>
                        <Select
                            options={this.state.countryCities}
                            maxMenuHeight="100%"
                            defaultInputValue={this.state.membercity}
                            onChange={opt => this.setCity(opt.label)}
                            key={this.state.membercity}
                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for="address">Physical address</Label>
                        <Input style={{ borderBlockColor: "red" }}
                            id="address"
                            name="address"
                            onChange={this.setAddress}
                            type="textarea"
                            rows="3"
                            value={this.state.memberaddress}
                        />
                    </FormGroup>
                    <FormGroup>
                        <label style={{ marginRight: "5px" }}>
                            Join date
                        </label>
                        <Input className="regDatePicker"
                            dateFormat="dd-MM-yyyy"
                            type='date'
                            value={this.state.memberjoindate}
                            onChange={(date) => this.handleJoinDateChange(date)}
                        />
                    </FormGroup>
                    <div style={{ paddingBottom: "10px" }}>
                        <span className=""><h5>DEPENDENTS DETAILS</h5></span>
                    </div>
                    <FormGroup>
                        <Label for='depgender'>Gender</Label>
                        <Select
                            options={this.genders}
                            maxMenuHeight="100%"
                            //key={this.genders.length}
                            //defaultInputValue={this.state.depSelectedGender}
                            onChange={opt => this.setDepGenderChange(opt.label)}
                            value={this.state.depSelectedGender}

                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for='depfullname'>Full name</Label>
                        <Input
                            type='text'
                            id='fullname'
                            name='fullname'
                            value={this.state.depFullname}
                            onChange={this.setDepFullName}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for='depphonenumber'>Phone number</Label>
                        <Input
                            type='number'
                            id='depphonenumber'
                            name='depphonenumber'
                            placeholder="+271234567896"
                            value={this.state.depPhonenumber}
                            onChange={this.setdepPhoneNumber}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for='depcountry'>Country of residence</Label>
                        <Select
                            options={this.countries}
                            maxMenuHeight="100%"
                            defaultInputValue=""
                            onChange={opt => this.setdepCountry(opt.label)}
                            value={this.state.depSelectedCountry}
                        ></Select>
                    </FormGroup>
                    <FormGroup>
                        <Label for='deprelation'>Relationship</Label>
                        <Select
                            options={this.relationships}
                            maxMenuHeight="100%"
                            defaultInputValue=""
                            onChange={opt => this.setdepRelationship(opt.label)}
                            value={this.state.depSelectedRelationship}
                        ></Select>
                    </FormGroup>
                    <div style={{ paddingBottom: "10px" }}>
                        <span>
                            <Button style={{ width: "40vw", backgroundColor: "rgb(89, 100, 95)", color: "white", fontWeight: "bold" }} text="Add depenedant++" onClick={this.addDependent}>Add dependant++</Button>
                        </span>
                    </div>
                    <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                        <table style={{ width: "100%", borderBottom: "1px solid white", borderCollapse: "collapse" }}>
                            <tr style={{ height: "5px", borderBottom: "1px solid white" }}>
                                <th> Gender</th>
                                <th> Full name</th>
                                <th> Phone</th>
                                <th> Relationship</th>
                                <th style={{ textAlign: "right" }}> Remove</th>
                            </tr>
                            {this.memberDependants.map((row, index) => {
                                return (<tr key={index} style={{ height: "25px", borderBottom: "1px solid white", width: "25px" }}>
                                    <>
                                        <td><Label style={{ color: "darkblue" }} >{row.depGender}</Label></td>
                                        <td><Label style={{ color: "darkblue" }}>{row.depFullname}</Label></td>
                                        <td><Label style={{ color: "darkblue" }}>{row.depPhonenumber}</Label></td>
                                        <td><Label style={{ color: "darkblue" }}>{row.depRelationship}</Label></td>
                                        <td style={{ border: "none" }}><button style={{ background: "none", color: "inherit", border: "none", float: "right", width: "10px" }}>
                                            <img src={deleteIcon} alt="Remove" style={{ height: "25px", width: "30px", alignItems: "flex-end" }}
                                                onClick={() => this.removeDependant(index)}></img>
                                        </button></td>
                                    </>
                                </tr>
                                );
                            })
                            }
                        </table>
                    </div>

                    <FormGroup>
                        <input
                            type="checkbox"
                            id="cbxterms"
                            name='cbxterms'
                        />
                        <Label style={{ paddingLeft: "5px" }} for='terms'>I accept the terms and conditions</Label>
                    </FormGroup>
                    <div id='successRegstration' style={{ textAlign: "center", color: "green", display: "none" }}><Label> <h4>Registration sent, thank you!</h4></Label></div>
                    <div id='failRegstration' style={{ textAlign: "center", color: "red", display: "none" }}><Label> <h4>Registration failed!</h4></Label></div>
                    <div style={{ paddingTop: "20px" }}></div>
                    <div id="btnSubmit" style={{ paddingTop: "20px" }}>
                        <Button style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", color: 'white', fontWeight: "bold" }} onClick={this.saveRegistration}>Submit</Button>
                    </div>
                    <div style={{ paddingTop: "20px" }}>
                        <Button style={{ width: "100%", fontWeight: "bold" }}
                            onClick={this.goToMenu}>
                            Close
                        </Button>
                    </div>
                    {/* </Form> */}
                </div>
            </div>
        );
    }
}

export default withNavigateHook(Home);
